export const reverseHeaderMenuChildrenTransitionDelay = (
  items,
  isReversed = false,
) => {
  const updatedItems = items.map(
    (item) => {
      if (item.children.length > 0) {
        return {
          ...item,
          children: item.children.map(
            (child, index) => {
              const transitionDelay = isReversed ?
                Math.abs(index - item.children.length) :
                index;
              return {
                ...child,
                transitionDelay,
              };
            },
          ),
        };
      }
      return item;
    },
  );
  return updatedItems;
};

export default {
  reverseHeaderMenuChildrenTransitionDelay,
};
